import { StartSocraticDialogueError } from "@/generated/graphql";

/** Which error page a failed start owes the student. */
export type StartFailure = "reattemptWindowExpired" | "unknown";

export function resolveStartFailure({
  startError,
  hasTransportError,
}: {
  /** The start payload's own error value. */
  startError: StartSocraticDialogueError | null;
  /** A transport or GraphQL failure, which carries no error value. */
  hasTransportError: boolean;
}): StartFailure | null {
  if (startError === StartSocraticDialogueError.OutsideReattemptWindow) {
    return "reattemptWindowExpired";
  }

  if (startError !== null || hasTransportError) {
    return "unknown";
  }

  return null;
}
